import { SlotGameType1_3 } from "../SlotGameType1_3";
export class FairyMagicForestClassic3 extends SlotGameType1_3{}
